/*
 * @Author: wha wha01707839@alibaba-inc.com
 * @Date: 2025-09-05 17:43:16
 * @LastEditors: wha wha01707839@alibaba-inc.com
 * @LastEditTime: 2025-09-28 15:08:44
 * @FilePath: /mj-weex-basic/src/pages/publicAgreements/index.tsx
 * @Description: 
 * 
 */
import { useEffect, useState } from "react";
import styles from './index.module.css';
import { canIUse, NavBar } from '@ali/hyper-api';
import { useUrlParams } from '@/hooks';
import { deviceInfo } from '@ali/bara-uni-api';
import parse from 'html-react-parser';
import { DotLoading } from '@ali/bara-uikit-loading';
export default function PublicAgreements() {
  const {
    urlParams,
    getPermissionWords
  } = useUrlParams();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [formData, setFormData] = useState<any>(null);
  const fetchData = async () => {
    setLoading(true);
    setErrorMsg('');
    try {
      let host = 'https://pre-yida-api.linkheer.com';
      if (window?.location?.host?.indexOf?.('wapa') > -1) {
        host = 'https://pre-yida-api.linkheer.com';
      } else {
        host = 'https://yida-api.linkheer.com';
      }
      const res = await fetch(`${host}/invoke/lc-1gecdevrpc01`, {
        method: 'POST',
        body: JSON.stringify({
          textField_mfasy1qr: urlParams.contractId
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (!res.ok) {
        throw new Error(`请求失败: ${res.status}`);
      }
      const data = await res.json();
      console.log('publicAgreements data:', data);
      const resultItem = data?.result?.[0];
      const nextFormData = resultItem?.formData ?? null;
      setFormData(nextFormData);
      // 设置title
      if (canIUse(NavBar.setTitle)) {
        NavBar.setTitle({
          title: nextFormData?.textField_m8zbdtzq ?? '协议'
        });
      }
      document.title = nextFormData?.textField_m8zbdtzq ?? '协议';
    } catch (err: any) {
      console.log(err, 'err');
      setErrorMsg("页面异常！请稍后再试");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (urlParams.contractId) {
      fetchData();
    }
  }, [urlParams.contractId]);
  return <div className={styles.container}>
   
      {loading && <div className={styles.loading}>
          <DotLoading color="#1890ff" />
          <span className={styles.loadingText}>加载中...</span>
        </div>}
      {!loading && errorMsg && <div className={styles.error}>
          <div className={styles.errorIcon}>⚠️</div>
          <div className={styles.errorText}>{errorMsg}</div>
          <button className={styles.retryBtn} onClick={() => {
        if (urlParams.contractId) {
          fetchData();
        }
      }}>
            重试
          </button>
        </div>}
      {!loading && !errorMsg && !!formData && <div className={styles.content}>
          {parse(formData?.editorField_mfasy1qs || '')}
        </div>}
    </div>;
}